<template>
    <div class="wrap-content ocr-config-page">
        <div class="filter-section">
            <div class="row">
                <div class="col-md-12">
                    <h2>AUM Configurations</h2>
                </div>
            </div>
        </div>

        <div v-if="!showPageLoader" class="config-card-switch">
            <div class="row">
                <div class="col-lg-12">
                    <div class="">
                        <div class="fields-area">
                            <div class="brand-color-area">
                                <div class="row">
                                    <div class="col-md-2">
                                        <label
                                            for=""
                                            class="min-height-40"
                                        ></label>
                                        <span>Medium</span>
                                    </div>
                                    <div class="col-lg-6">
                                        <b-form-group
                                            id="label-medium"
                                            label="Amount in base currency"
                                            label-for="medium"
                                        >
                                            <b-form-input
                                                id="low"
                                                v-model="formData.medium.value"
                                                v-validate="{
                                                    required: true,
                                                    numeric: true,
                                                }"
                                                :class="{
                                                    'is-invalid':
                                                        errors.has('medium'),
                                                }"
                                                type="text"
                                                name="medium"
                                                placeholder="Enter amount"
                                            ></b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4 form-radio">
                                        <b-form-group
                                            id="status"
                                            label="Status"
                                            label-for="medium status"
                                        >
                                            <b-form-radio-group
                                                v-model="formData.medium.status"
                                                :options="radioOptions"
                                                name="medium status"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <label
                                            for=""
                                            class="min-height-40"
                                        ></label>
                                        <span>High</span>
                                    </div>
                                    <div class="col-lg-6">
                                        <b-form-group
                                            id="label-high"
                                            label="Amount in base currency"
                                            label-for="high"
                                        >
                                            <b-form-input
                                                id="high"
                                                v-model="formData.high.value"
                                                v-validate="{
                                                    required: true,
                                                    numeric: true,
                                                }"
                                                :class="{
                                                    'is-invalid':
                                                        errors.has('high'),
                                                }"
                                                type="text"
                                                name="high"
                                                placeholder="Enter amount"
                                            ></b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4 form-radio">
                                        <b-form-group
                                            id="high-status"
                                            label="Status"
                                            label-for="high-status"
                                        >
                                            <b-form-radio-group
                                                v-model="formData.high.status"
                                                :options="radioOptions"
                                                name="high status"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                                <div class="row">
                                    <div class="col-md-2">
                                        <label
                                            for=""
                                            class="min-height-40"
                                        ></label>
                                        <span>Sanctioned</span>
                                    </div>
                                    <div class="col-lg-6">
                                        <b-form-group
                                            id="label-sanctioned"
                                            label="Amount in base currency"
                                            label-for="sanctioned"
                                        >
                                            <b-form-input
                                                id="sanctioned"
                                                v-model="
                                                    formData.sanctioned.value
                                                "
                                                v-validate="{
                                                    required: true,
                                                    numeric: true,
                                                }"
                                                :class="{
                                                    'is-invalid':
                                                        errors.has(
                                                            'sanctioned'
                                                        ),
                                                }"
                                                type="text"
                                                name="sanctioned"
                                                placeholder="Enter amount"
                                            ></b-form-input>
                                        </b-form-group>
                                    </div>
                                    <div class="col-md-4 form-radio">
                                        <b-form-group
                                            id="sanctioned-status"
                                            label="Status"
                                            label-for="sanctioned-status"
                                        >
                                            <b-form-radio-group
                                                v-model="
                                                    formData.sanctioned.status
                                                "
                                                :options="radioOptions"
                                                name="sanctioned status"
                                            ></b-form-radio-group>
                                        </b-form-group>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-lg-12">
                                <b-button
                                    :class="loading ? 'disabled' : ''"
                                    variant="primary"
                                    type="submit"
                                    @click.prevent="updateAUMConfigurations()"
                                >
                                    <span class="btn-text">UPDATE</span>
                                    <span class="loader"></span>
                                </b-button>
                                <base-toast></base-toast>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- When data is loading -->
                <base-table-spinner v-if="showPageLoader"></base-table-spinner>
            </div>
        </div>
        <!-- When data is loading -->
        <base-table-spinner v-if="showPageLoader"></base-table-spinner>
    </div>
</template>

<script>
import { mapGetters } from 'vuex'
import resource from '@/api/resource'
const aumApi = new resource('configurations/aum')
export default {
    components: {},

    /*
    |--------------------------------------------------------------------------
    | Component > props
    |--------------------------------------------------------------------------
    */
    props: {}, // End of Component > props

    /*
    |--------------------------------------------------------------------------
    | Component > data
    |--------------------------------------------------------------------------
    */
    data() {
        return {
            showPageLoader: true,
            formData: {
                _id: null,
                dataSegmentId: null,
                medium: {
                    value: null,
                    status: 'inactive',
                },
                high: {
                    value: null,
                    status: 'inactive',
                },
                sanctioned: {
                    value: null,
                    status: 'inactive',
                },
            },
            radioOptions: [
                { text: 'Active', value: 'active' },
                { text: 'Inactive', value: 'inactive' },
            ],
        }
    }, // End of Component > data

    /*
    |--------------------------------------------------------------------------
    | Component > computed
    |--------------------------------------------------------------------------
    */
    computed: {
        ...mapGetters(['dataSegmentId', 'loading', 'data']),
    }, // End of Component > computed
    /*
    |--------------------------------------------------------------------------
    | Component > watch
    |--------------------------------------------------------------------------
    */
    watch: {
        dataSegmentId(value) {
            if (value) {
                this.getAumData()
            }
        },
    }, // End of Component > watch
    /*
    |--------------------------------------------------------------------------
    | Component > mounted
    |--------------------------------------------------------------------------
    */
    mounted() {
        this.getAumData()
    }, // End of Component > mounted
    /*
    |--------------------------------------------------------------------------
    | Component > methods
    |--------------------------------------------------------------------------
    */
    methods: {
        async getAumData() {
            try {
                if (this.dataSegmentId) {
                    this.formData.dataSegmentId = this.dataSegmentId
                    let { data } = await aumApi.list({
                        dataSegmentId: this.dataSegmentId,
                    })
                    if (!_.isEmpty(data.data)) {
                        this.formData = data.data
                    }
                    this.showPageLoader = false
                }
            } catch (error) {
                this.showPageLoader = false
            }
        },
        async updateAUMConfigurations() {
            const result = await this.$validator.validateAll()
            if (result) {
                try {
                    // update aum configurations
                    this.$store.commit('setLoading', true)
                    let { data } = await aumApi.update(
                        this.formData._id,
                        this.formData
                    )
                    await this.getAumData()
                    this.$store.commit('setLoading', false)
                    this.$store.commit('setSuccess', data.message)
                } catch (error) {
                    this.$store.commit('setError', error)
                    this.$store.commit('setLoading', false)
                }
            } else {
                this.$store.commit('setError', this.errors.all()[0])
            }
        },
    }, // End of Component > methods
} // End of export default
</script>
